import { useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads", { type: "contact", payload: form });
      toast.success("Message sent. We'll respond within one business day.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Couldn't send."); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-[1200px] mx-auto px-5 lg:px-10 py-16" data-testid="contact-page">
      <p className="label-mono mb-3">Contact</p>
      <h1 className="font-display text-4xl md:text-6xl font-light tracking-tighter mb-12">Let's talk.</h1>
      <div className="grid md:grid-cols-2 gap-10">
        <div className="space-y-6">
          <div className="flex items-start gap-4 p-5 rounded-2xl bg-[#0A0A0E] border border-[#1A1A24]">
            <Phone className="w-5 h-5 text-silver mt-1" />
            <div><div className="label-mono mb-1">Call</div><div className="font-display text-xl">1-555-AUTO-BRK</div><div className="text-xs text-gray-500 mt-1">Mon-Sat · 9am-7pm ET</div></div>
          </div>
          <div className="flex items-start gap-4 p-5 rounded-2xl bg-[#0A0A0E] border border-[#1A1A24]">
            <Mail className="w-5 h-5 text-silver mt-1" />
            <div><div className="label-mono mb-1">Email</div><div className="font-display text-xl">hello@555auto.com</div><div className="text-xs text-gray-500 mt-1">Replies within 1 business day</div></div>
          </div>
          <div className="flex items-start gap-4 p-5 rounded-2xl bg-[#0A0A0E] border border-[#1A1A24]">
            <MapPin className="w-5 h-5 text-silver mt-1" />
            <div><div className="label-mono mb-1">HQ</div><div className="font-display text-xl">Charlotte, NC</div><div className="text-xs text-gray-500 mt-1">Nationwide delivery</div></div>
          </div>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-7 md:p-10 space-y-3" data-testid="contact-form">
          <Input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-[#0A0A0E] border-[#1A1A24] h-12 rounded-xl text-white" data-testid="contact-name" />
          <Input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-[#0A0A0E] border-[#1A1A24] h-12 rounded-xl text-white" data-testid="contact-email" />
          <Input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="bg-[#0A0A0E] border-[#1A1A24] h-12 rounded-xl text-white" data-testid="contact-phone" />
          <textarea required rows={5} placeholder="How can we help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-[#0A0A0E] border border-[#1A1A24] rounded-xl text-white p-3 text-sm" data-testid="contact-message" />
          <button type="submit" disabled={busy} className="w-full silver-gradient text-[#050507] font-bold py-3.5 rounded-full disabled:opacity-50" data-testid="contact-submit">{busy ? "Sending…" : "Send"}</button>
        </form>
      </div>
    </div>
  );
}
